export function scrollToAnchor(height = 0, lowSpeed = 50, scrollElement) {
  scrollElement = scrollElement || document.scrollingElement
  const maxHeight = scrollElement.scrollHeight - document.documentElement.clientHeight
  height = Math.min(maxHeight, height)

  function step() {
    const progress = Math.ceil(scrollElement.scrollTop / 10)

    if (height > scrollElement.scrollTop) {
      scrollElement.scrollTop += Math.max(progress, lowSpeed)
      if (scrollElement.scrollTop < height) {
        window.requestAnimationFrame(step)
      } else {
        scrollElement.scrollTop = height
      }
    } else {
      scrollElement.scrollTop -= Math.max(progress, lowSpeed)
      if (scrollElement.scrollTop > height) {
        window.requestAnimationFrame(step)
      } else {
        scrollElement.scrollTop = height
      }
    }
  }

  window.requestAnimationFrame(step)
}
